import { render } from "./ActiveDemo.vue?vue&type=template&id=3e0ab8cb"
import script from "./ActiveDemo.vue?vue&type=script&lang=js"
export * from "./ActiveDemo.vue?vue&type=script&lang=js"

import "./ActiveDemo.vue?vue&type=style&index=0&id=3e0ab8cb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__